<template>
  <canvas></canvas>
</template>

<script>
import $ from 'jquery'
import {
  CategoryScale,
  Chart,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js'

Chart.register(
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Tooltip
)

export default {
  components: {},
  props: {
    labels: {
      required: true,
      type: Array,
    },
    datasets: {
      required: true,
      type: Array,
    },
    graphUpdateCounter: {
      type: Number,
      default: 0,
    },
    type: {
      required: true,
      type: String,
    },
  },
  mounted() {
    this.elem = $(this.$el)

    this._iniChart() 
  },
  methods: {
    _iniChart: function () {
      const ctx = this.elem[0].getContext('2d')

      const chartDatasets = this.datasets

      const colors = this.type === 'multiline' ? true : false
      const typeChart = this.type

      chartDatasets.forEach((dataset) => {
        (dataset.pointRadius = 4), (dataset.pointStyle = 'circle')
      })
     
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.labels,
          datasets: chartDatasets,
        },
        options: {
          interaction: {
            mode: 'index',
            intersect: false,
          },
          plugins: {
            tooltip: {
              // enabled: true,
              backgroundColor: '#fff',
              padding: 8,
              bodyFont: {
                family: 'AeonikPro ,  sans-serif',
                size: 14,
                weight: 700,
              },
              bodyColor: '#5B6069',
              displayColors: colors,
              callbacks: {
                label: function (context) {               

                  if (typeChart === 'multiline') {
                    const dataset = context.dataset
                    const index = context.dataIndex
                    const data = dataset.data[index]
                    const percentage = dataset.percentage[index]
                    return data + '€' + ', ' + percentage
                  }
                  if (typeChart === 'line') {
                    return `${context.formattedValue}€`
                  }
                },

                title: () => null,
              },
            },
          },
          scales: {
            x: {
              beginAtZero: true,
            },
            y: {
              beginAtZero: true,
            },
          },
        },
      })
    },
  },
}
</script>
